module.exports = __webpack_public_path__ + "static/Group 7200-b057a2e21ac31ad9bf93d834383d9543.png";